import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

const detailsQuery = graphql`
	query SEOQuery {
		site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
			title
			openGraph {
				title
				description
			}
		}
	}
`;

interface SEOProps {
	description?: string;
	lang?: string;
	meta?: any[];
	keywords?: string[];
	title: string;
	imageUrl?: string;
}

export function SEO({
	description,
	imageUrl,
	keywords = [],
	lang = 'en',
	meta = [],
	title,
}: SEOProps) {
	const { pathname } = useLocation();
	const metaImage = imageUrl ?? 'https://helloalma.com/og-hero.jpg';
	const metaUrl = `https://helloalma.com${pathname}`;

	const data = useStaticQuery(detailsQuery);

	if (!data.site) {
		return;
	}

	const metaDescription = description ?? data.site.openGraph.description;

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			titleTemplate={
				title === data.site.title ||
				title?.includes('— Alma') ||
				title?.includes('Alma —')
					? '%s'
					: `%s — ${data.site.title}`
			}
			meta={[
				{
					name: 'description',
					content: metaDescription,
				},
				{
					property: 'og:title',
					content: title,
				},
				{
					property: 'og:description',
					content: metaDescription,
				},
				{
					property: `og:image`,
					content: metaImage,
				},
				{
					property: `og:url`,
					content: metaUrl,
				},
				{
					property: 'og:type',
					content: 'website',
				},
				{
					property: `og:logo`,
					content:
						'https://secure.helloalma.com/static/website/images/logos/logo-primary%402x.png',
				},
				{
					name: 'twitter:card',
					content: 'summary',
				},
				{
					name: 'twitter:creator',
					content: data.site.author,
				},
				{
					name: 'twitter:title',
					content: title,
				},
				{
					name: 'twitter:description',
					content: metaDescription,
				},
			]
				.concat(
					keywords && keywords.length > 0
						? {
								name: 'keywords',
								content: keywords.join(', '),
							}
						: []
				)
				.concat(meta)}
		/>
	);
}
